import { pageContentBlocks } from 'app/blocks'
import { gql } from 'graphql-request'

export const upperCaseFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export type CollectionType = 'Collection' | 'Tag' | 'MemberTier'

export const createCollectionFragment = (
  type: CollectionType = 'Collection',
  includeContent?: boolean
) => gql`
  ${includeContent ? pageContentBlocks : ''}
  fragment collection on ${type} {
    id
    name
    subtitle
    slug
    thumbnail {
      id
      sizes {
        thumbnail {
          url
        }
      }
    }
    itemCount
    ${
      includeContent
        ? `
    pageContent { 
      __typename
      ...richTextFragment 
      ...bannerFragment 
      ...imageFragment
      ...videoFragment
      ...externalImageFragment
      ...featuredFragment
      ...faqsFragment
      ...collectableRedemptionFormFragment
      ...productGridFragment
      ...formFragment
      ...redeemCollectableFragment
      ...buttonFragment
    }`
        : ''
    }
  }
`
